import { useEffect, useState } from "react";
import axios from "axios";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PartnersMarquee() {
  const [partenaires, setPartenaires] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setPartenaires(r.data.partenaires || [])).catch(() => {});
  }, []);

  if (partenaires.length === 0) return null;

  const row = [...partenaires, ...partenaires];
  return (
    <div data-testid="partners-marquee" className="border-b border-[#27272A] bg-[#121214] py-5 overflow-hidden">
      <p className="text-center text-[10px] uppercase tracking-[0.4em] text-[#71717A] mb-4">{t("partners.title")}</p>
      <div className="animate-marquee flex w-max whitespace-nowrap items-center">
        {row.map((p, i) => (
          <span key={i} className="flex items-center">
            {p.logo ? (
              <img src={p.logo} alt={p.nom} title={p.nom} className="h-9 w-auto mx-8 object-contain grayscale hover:grayscale-0 transition-[filter] duration-300" />
            ) : (
              <span className="font-display uppercase text-lg tracking-wider text-[#A1A1AA] px-8">{p.nom}</span>
            )}
            <span className="text-[#C5A059] text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
